<template>
  <div class="page-wrap FinanceDetail-page" ref="container">
		<List :refresh="false" :label="label" apiName="petSettlementDetail" :options="options" ref="list" :noPage="true"></List>
  </div>
</template>
<script>
import List from "@components/List";

export default {
  name: "PetAdminFinanceDetail",
  components: {
		List,
  },
  props: {},
  data: function() {
    return {
			options : {
				id : this.$route.params.id,
			},
      filter: {
      },
			searchLabel : [],
			label : [
				{field : 'machineCode', title : '所属设备'},
				{field : 'orderId', title : '订单号'},
				{field : 'priceTypeStr', title : '收益类型'},
				{field : 'expectPrice', title : '金额', type : "num"},
				{field : 'time', title : '', type : "date"},
			],
      list: [],
    };
  },
  watch: {
    $route(n) {
      if (n.name === 'PetAdminFinanceDetail') {
				this.options = this.$route.params
				this.search(this.options);
      }
    }
  },
  mounted: function() {
  },
  computed: {},
  methods: {
		search(filter) {
			this.filter = filter;
			this.$refs.list.reload(filter);
		},
  }
};
</script>
<style lang="scss">
body {background: #F9F9F9 !important;}
.page-wrap {
	padding: 0.3rem;
}
</style>
